
    const data = {"name":"heart","data":{"width":"18","height":"17","viewBox":"0 0 18 17","data":"<path pid=\"0\" d=\"M16.25 1.944A4.73 4.73 0 0 0 12.78.417a4.734 4.734 0 0 0-3.473 1.527l-.306.326-.306-.326a4.71 4.71 0 0 0-6.944 0 5.398 5.398 0 0 0 0 7.292l6.8 7.235a.616.616 0 0 0 .9 0l6.798-7.235a5.397 5.397 0 0 0 0-7.292Z\" _fill=\"#000\"/>","originalColors":[{"type":"fill","color":"#000"}],"stopColors":[]}}

            export default data
            